import './Alert.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Alert extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    success: PropTypes.bool,
    failure: PropTypes.bool
  }

  static defaultProps = {
    success: false,
    failure: false,
  }

  render() {
    const { failure, success, message, onCloseClick } = this.props;
    const stateClass = failure ? 'failure' : success ? 'success' : '';

    return (
      <div className={`alert-container ${stateClass}`}>
        <div className="close" onClick={onCloseClick}>&times;</div>
        <div className={`alert ${stateClass}`}>
          <strong dangerouslySetInnerHTML={{ __html: message }}></strong>
        </div>
      </div>
    );
  }
}
